(ns manage.export-display-tag-ocp.db
  (:require [common.db.effects.http]
            [common.form.core :as form]
            [common.ocp.db]
            [common.queries :refer [use-query]]
            [common.resource.query.adserver :as adserver.q]
            [common.resource.query.adserver-account-configuration :as adserver-config.q]
            [re-frame.core :as rf]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def initial-state {:exportName nil
                    :adserverId nil
                    :adserveraccountconfigurationId nil})

(form/register-form {:namespace :form.export-display-tag
                     :initial-value initial-state})

(def use-bind-control (partial form/use-bind-control :form.export-display-tag))

(rf/reg-event-fx :campaign-tags.page/export-display-tag
  (fn [_ _]
    {:dispatch [:ocp/open {:id :export-display-tag-ocp}]}))

(rf/reg-event-fx :form.export-display-tag/init
  [(rf/inject-cofx :sub :campaign-tags.page/first-display-adset)
   (rf/inject-cofx :sub :campaign-tags.page/has-multiple-adsets?)]
  (fn [{:keys [db :campaign-tags.page/first-display-adset :campaign-tags.page/has-multiple-adsets?]} _]
    (let [default-name (if has-multiple-adsets?
                         ""
                         (:adset-name first-display-adset))
          form-state (merge initial-state {:exportName default-name})]
      {:db (assoc-in db [:form.export-display-tag :value] form-state)})))

(rf/reg-event-db :form.export-display-tag/destroy
  (fn [db _]
    (dissoc db :form.export-display-tag)))

(defhook use-cm360-adserver-option []
  (let [{adservers :data} (use-query (adserver.q/adservers-query))
        cm360-adserver (some->> adservers
                                (filter #(= "Google CM360" (:name %)))
                                first)]
    (when (some? cm360-adserver)
      {:label (:name cm360-adserver) :value (:id cm360-adserver)})))

(defhook use-target-export-options []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {adserver-configs :data} (use-query (adserver-config.q/adserver-account-configurations-query
                                             {:advertiser-id advertiser-id}))
        {cm360-adserver-id :value} (use-cm360-adserver-option)]
    (when cm360-adserver-id
      (->> adserver-configs
           (filter #(= cm360-adserver-id (get-in % [:adserveraccount :adserver :id])))
           (map #(hash-map :label (get-in % [:adserveraccount :name])
                           :value (:id %)))))))
